import React, { useState, useEffect, useRef } from 'react';
import ModalBase from './ModalBase';
import { FaInstagram, FaYoutube, FaSpotify } from "react-icons/fa";

const Bio = ({ isOpen, onClose }) => {
  const audioRef = useRef(null);
  useEffect(() => {
    // Reproducir el audio cuando el modal se abre
    if (isOpen && audioRef.current) {
      audioRef.current.play();
    }
  }, [isOpen]); // Se ejecuta cada vez que 'isOpen' cambia
  return (
    <ModalBase isOpen={isOpen} onClose={onClose} title="Instructivo">
      {/* Reproductor de audio invisible */}
      <audio ref={audioRef} src="/INSTRUCTIVO.mp3" preload="auto" />
      <div className="space-y-8 mx-auto p-6 text-black shadow-lg rounded-lg">
        <p className="text-lg flex flex-col">
          Relájese, incline la cabeza y piense en lo bello que puede ser un día de campo. Piense en un planeta que no es el suyo, piense en una persona nueva que lo habita. Imagine que le hace un regalo.
          <span>
            Imite la forma que puede tener un fruto silvestre y contorsione su cuerpo hasta emularlo. Verá lo lejos que puede llegar si tiene la astucia de controlar sus pliegues.
          </span>
          <span>
            Disque en su móvil 1864 y espere en línea. Presione varios botones hasta dar con la opción deseada. Despéinese si siente el cuero cabelludo tenso.
          </span>
        </p>
        <p className="text-lg flex flex-col">
          Maniobre ideas para lograr que cada sonido que escuche caiga en el costado derecho del cerebro. Cómprese tiempo y navegue limpio con los ojos frescos. No piense en la escucha como una actividad pasajera.
          <span>
            Viaje, aun si no tiene forma de salir de su centro haga un esfuerzo por trascender su piel

          </span>
          <span>
            y viaje.
          </span>
        </p>
        <p className='text-lg flex flex-col'>
          Llame a un amigo para invitarlo al desafío. Él se resistirá. Insista.
          <span>
            Escriba las impresiones que ha tenido y háganoslas llegar por algún medio.
          </span>
        </p>
        <p className='text-lg flex flex-col'>
          Vuelva a discar 1864.
          <span>Olvide todo lo anterior.</span>
        </p>

      </div>
    </ModalBase >
  );
};

export default Bio;
